import axios from "axios";

export const repertorizarHomeosiniatria = async (codigos) => {
  const { data } = await axios.get("/api/repertorizacion/homeosiniatria/", {
    params: {
      codigos,
    },
  });
  return data;
};
